uniform float uParticleSize;
uniform float uProjectionScale; // viewportHeightPx / (2 * tan(fov/2))

varying vec3 vWorldPos;

varying float vCameraDistance;

void main() {
  vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
  gl_Position = projectionMatrix * mvPosition;

  // Базовый размер и масштаб по расстоянию (перспективное масштабирование)
  gl_PointSize = uParticleSize * uProjectionScale * (1.0 / -mvPosition.z);
  vCameraDistance = mvPosition.z;

  vWorldPos = (modelMatrix * vec4(position, 1.0)).xyz;
}


